<template>
    <div class="relative flex justify-center items-center">
        <hr class="absolute inset-x-0">
        <div class="relative px-2 bg-white">
            <button
                class="inline-flex p-1 border border-gray-300"
                @click.prevent.stop="$emit('click')">
                <font-awesome-icon icon="plus" size="xs"/>
            </button>
        </div>
    </div>
</template>
